/**
 *    SPDX-License-Identifier: Apache-2.0
 */

export const modeSelector = state => state.theme.mode;
